<template>
    <div v-loading="loading" class="alarmClass">
      <div>
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="所属车场" prop="spaceId">
                <el-select
                v-model="form.spaceId"
                disabled
                style="width:100%"
                placeholder="所属车场"
                @change="spaceIdChange"
              >
                <el-option
                  v-for="item in spaceIdList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              </el-form-item>
            </el-col>
  
          
            <el-col :span="12">
              <el-form-item label="优惠规则" prop="templateType">
                <el-input
                clearable
                v-model="form.name"
                placeholder="优惠规则"
                maxlength="30"
              ></el-input>
              </el-form-item>
            </el-col>
           
            <el-col :span="12">
              <el-form-item label="套餐类型" prop="isDouble">
                
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收费规则" prop="templateType">
              
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item label="缴费期数(月)" prop="payPeriods">
                <el-input-number v-model="form.payPeriods" :min="1" :max="999" label="缴费期数(月)"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item label="减免类型" prop="discountType">
                <el-radio-group v-model="form.discountType">
                <el-radio :label="1">减免月份</el-radio>
                <el-radio :label="2">减免固定金额</el-radio>
                <el-radio :label="3">优惠折扣</el-radio>
            </el-radio-group>
              </el-form-item>
            </el-col>
           
            <el-col :span="24" >
              <el-form-item label="备注" prop="description">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="请输入备注"
                  v-model="form.description" 
                  :disabled="model == 'view'"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="    text-align: right;" v-if="model != 'view'">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
          {{ model == 'add' ? '提交' : '修改' }}
        </el-button>
        <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
          取消
        </el-button>
       
      </div>
    </div>
  </template>
  <script>

  import { getDictionary } from '@/api/common.js';
 import {getParkList} from "./carMaster/index.js"
  export default {
    components: {  },
    props: {
      row: {
        default: {},
      },
      spaceId:{},
      model: {},
    },
    data() {
      return {
        spaceStatusData:[
           
            {
                dictKey:'1',
                dictValue:'已出售',
            },
            {
                dictKey:'2',
                dictValue:'空闲',
            },
        ],
        isDoubleData:[
            {
                dictKey:'0',
                dictValue:'否',
            },
            {
                dictKey:'1',
                dictValue:'是',
            },
            
        ],
       
        regionList:[],
        alarmListRules: {
          variableId: [{ required: true, message: ' ', trigger: 'change' }],
          polymerizeType: [{ required: true, message: ' ', trigger: 'change' }],
          monitorCycleType: [{ required: true, message: ' ', trigger: 'change' }],
          monitorThresholdCondition: [{ required: true, message: ' ', trigger: 'change' }],
          monitorVariableValue: [{ required: true, message: ' ', trigger: 'blur' }],
          triggerCycleType: [{ required: true, message: ' ', trigger: 'change' }],
          alarmFrequencyType: [{ required: true, message: ' ', trigger: 'change' }],
          alarmLevel: [{ required: true, message: ' ', trigger: 'change' }],
          
        },
      
        form: {
            spaceId:'',
            discountName:'',
            carCategory :'',
            carType:'',
            payPeriods:'',
            discountType:'',
            discountNumber:'',
            remark :'',
              
        },
    
        formRules: {
          name: [{ required: true, message: '告警名称不能为空', trigger: 'blur' }],
          templateId: [{ required: false, message: '变量模板不能为空', trigger: 'change' }],
          notifyGroupIds: [{ required: true, message: '通知班组不能为空', trigger: 'change' }],
          notifyWays: [{ required: true, message: '推送方式不能为空', trigger: 'blur' }],
          deviceIds: [{ required: true, message: '设备不能为空', trigger: 'change' }],
          orderModuleType: [{ required: true, message: '工单类型不能为空', trigger: 'change' }],
          templateType: [{ required: true, message: '通信协议不能为空', trigger: 'change' }],
        },
        tableHeight: '',
        spaceIdList:[]
      };
    },
    created() {
      this.initData();
    },
    mounted() {
    
    },
    watch:{
      
    },
    methods: {
      
      initData() {
         getParkList().then((res) => {
          this.spaceIdList = res.data;
         
        });
       
        this.form.spaceId = this.spaceId
        getRegionList({
            spaceId:this.form.spaceId
        }).then((res) => {
            this.regionList = res.data



             
        })
        
      
       
       
      },
      saveRecord() {
        console.log(this.form);
        console.log(this.strategyList);
        let formRefValidate = false;
        console.log(this.$refs);
        this.$refs['formRef'].validate((valid) => {
          formRefValidate = valid;
        });
        let alarmListValide = true;
        this.strategyList.forEach((item, index) => {
          console.log(index);
          let str = 'alarmListRef' + index;
          this.$refs[str].validate((valid) => {
            if (valid) {
            } else {
              alarmListValide = false;
            }
          });
        });
        let alarmList1Valide = true;
        this.strategyList.forEach((item, index) => {
          let str = 'alarmList1Ref' + index;
          this.$refs[str].validate((valid) => {
            if (valid) {
            } else {
              alarmList1Valide = false;
            }
          });
        });
        let alarmList2Ref = true;
        this.strategyList.forEach((item, index) => {
          let str = 'alarmList2Ref' + index;
          this.$refs[str].validate((valid) => {
            if (valid) {
            } else {
              alarmList2Ref = false;
            }
          });
        });
        //校验所有的表单
        if (formRefValidate && alarmListValide && alarmList1Valide && alarmList2Ref) {
          this.form.strategyList = this.strategyList;
          if (this.model == 'add') {
            alarmRuleSave(this.form).then((res) => {
              this.$message({
                type: 'success',
                message: '新增成功!',
              });
              this.$emit('success');
            });
          } else {
            alarmRuleUpdate(this.form).then((res) => {
              this.$message({
                type: 'success',
                message: '编辑成功!',
              });
              this.$emit('success');
            });
          }
        }
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  </style>
  